import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button } from '@material-ui/core';

const DialogWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const DialogContent = styled.div`
  background: ${props => props.backgroundColor};
  padding: 10px 20px;
  max-width: 500px;
  border-radius: 16px;
  box-shadow: 0 8px 12px rgba(0, 0, 0, 0.3);
  text-align: center;
  position: relative;
  font-family: 'Arial', sans-serif;
  color: ${props => props.textColor};
`;

const AlertDialog = ({ onDismiss, alert, alertMessage, backgroundColor, textColor }) => (
  <DialogWrapper>
    <DialogContent backgroundColor={backgroundColor} textColor={textColor}>
      <h2 style={{ marginBottom: '10px', fontSize: '1.5rem', fontWeight: 'bold', marginTop: '10px' }}>
        {alert}
      </h2>
      <p style={{ textAlign: 'center', marginBottom: '12px', fontSize: '1rem' }}>
        {alertMessage}
      </p>
      <Button
        type="button"
        onClick={onDismiss}
        style={{
          padding: '3px 20px',
          fontSize: '14px',
          backgroundColor: '#497205',
          color: '#fff',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer',
          margin: '10px 0 10px 0',
          textTransform: 'uppercase',

        }}
      >
        OK
      </Button>
    </DialogContent>
  </DialogWrapper>
);
AlertDialog.propTypes = {
  alert: PropTypes.string,
  alertMessage: PropTypes.string,
  backgroundColor: PropTypes.string,
  onDismiss: PropTypes.func.isRequired,
  textColor: PropTypes.string,
};

export default AlertDialog;
